import $ from 'jquery';

import { CreateNewLeadPopupCtrl } from '../create.new.lead.popup/create.new.lead.popup.controller';
import newLeadPopupTemplate from '../create.new.lead.popup/create.new.lead.popup.html';
import leadContainer from '../lead.popup/LeadContainer.directive';
import template from '../leads/leads.html';
import sidebarTemplate from '../leads/leads.sidebar.html';
import unitContainer from '../unit.popup/UnitContainer.directive';
import { LeadsCtrl } from './leads.controller';

routesConfig.$inject = ['$stateProvider'];

export function routesConfig($stateProvider) {
  $stateProvider
    .state('leads', {
      url: '/leads',
      controller: LeadsCtrl,
      controllerAs: 'vm',
      template: `${template}<div ${unitContainer.htmlName}></div><div ${leadContainer.htmlName}></div>`,
      redirectTo: 'leads.search',
    })
    .state('leads.search', {
      url: '/search',
      views: {
        sidebar: {
          template: sidebarTemplate,
        },
      },
    })
    .state('leads.unitpopup', {
      url: '/unit/:id',
      // views: {
      //   sidebar: {
      //     template: () => `<div ${unitContainer.htmlName}></div>`,
      //   },
      // },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    })
    .state('leads.leadpopup', {
      url: '/lead/:id',
      // we are lifting the actual lead popup to the root
      // to fix issue with remounting on route change and animation repeats
      // views: {
      //   sidebar: {
      //     template: () => `<div ${leadContainer.htmlName}></div>`,
      //   },
      // },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    })
    .state('leads.leadpopup.opportunity', {
      url: '/opportunity/:opportunityId',
    })
    .state('leads.new', {
      url: '/new?phone',
      views: {
        sidebar: {
          controller: CreateNewLeadPopupCtrl,
          controllerAs: 'vm',
          template: newLeadPopupTemplate,
        },
      },
      params: { phoneOrEmail: null },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    });
}
